import httpService from "../../Service/httpService";

const controller = "Pacientes";

export const getDatosPaciente = async (id, idPac) => {
  const res = await httpService.get(
    `/${controller}/getDatosPaciente/${id}/${idPac}`,
  );
  return res.data;
};

export const getPacientes = async (id, filtro) => {
  const res = await httpService.get(
    `/${controller}/getPacientes/${id}/${filtro}`,
  );
  return res.data;
};

// Expediente Paciente
export const getExpediente = async (id, idPac) => {
  const res = await httpService.get(
    `/${controller}/getExpediente/${id}/${idPac}`,
  );
  return res.data;
};

export const getEstadosMedicosPac = async (id, idPac) => {
  const res = await httpService.get(
    `/${controller}/getEstadosMedicosPac/${id}/${idPac}`,
  );
  return res.data;
};

export const getNombreDuplicado = async (id, nombre) => {
  const res = await httpService.get(
    `/${controller}/getNombreDuplicado/${id}/${nombre}`,
  );
  return res.data;
};

export const getResumenDocs = async (id) => {
  const res = await httpService.get(
    `/${controller}/getResumenDocs/${id}`,
  );
  return res.data;
};

export const getListPacientes = async (id) => {
  const res = await httpService.get(
    `/${controller}/getListPacientes/${id}`,
  );
  return res.data;
};

export const savePaciente = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveDatos`, {
    ...data,
  });
  return res;
};


export const saveEstadoMedicoPac = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveEstadoMedicoPac`, {
    ...data,
  });
  return res;
};

export const saveAuthReq = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveAuthReq`, {
    ...data,
  });
  return res;
};


export const saveModalFiltro = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/saveModalFiltro`, {
    ...data,
  });
  return res;
};

export const eliminaDocExped = async (data) => {
  //   const userData = getDecodedToken();
  const res = await httpService.post(`/${controller}/eliminaDocExped`, {
    ...data,
  });
  return res;
};

export const saveDocumento = async (formData) => {
  try {
    const response = await httpService.post(`/${controller}/saveDocumento`, formData, {
      headers: {
        // Axios automatically sets the correct Content-Type for FormData,
        // but explicitly setting it to multipart/form-data can also work
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log('File upload successful:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error uploading file:', error);
    throw error;
  }
};
